export default "__VITE_ASSET__7bb2b300__"